module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c6ab876","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 292
// module chunks = 1